import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useParticipantIds, useActiveParticipant, useDaily } from '@daily-co/daily-react';
import { pageAtom, isAuthAtom } from '../../State';
import { useNavigate, useParams } from 'react-router-dom';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { ReactComponent as CloseSVG } from '../Images/buttons/closeBlackButton.svg';
import { ReactComponent as BackArrowSVG } from '../Images/buttons/backArrow.svg';
import { ReactComponent as ListSVG } from '../Images/buttons/listholder.svg';
import { ReactComponent as AddMyAvatarSVG } from '../Images/buttons/addMyAvatarButton.svg';
import KUTE from 'kute.js';
import './NFT.css';
import 'react-loading-skeleton/dist/skeleton.css';
import NFTItem from './NFTItem';
import Loading from '../Loading/Loading';
import NoMetaMask from '../ElectronMetaMask/NoMetaMask';
import DownloadApp from './DownloadApp';
import DataModel from '../Util/DataModel';
import Skeleton from 'react-loading-skeleton';
import NFTPartnerDetail from './NFTPartnerDetail';
import NFTMy from './NFTMy';
import AddAccess from '../Util/AddAccess';
import { useTranslation } from 'react-i18next';
import { getImagePath } from '../Util/utils';
import { isMobile } from 'react-device-detect';
import isElectron from '../../Global';
import NFTMyCustom from './NFTMyCustom';
import NFTBackground from './NFTBackground';
import NFTBGM from './NFTBGM';

export default function NFT({ isFaceScreen = false, userType }) {
  const callObject = useDaily();

  //Recoil系
  const [pageState, setPageState] = useRecoilState(pageAtom);
  const [isAuthState, setAuthState] = useRecoilState(isAuthAtom);
  const { t, i18n } = useTranslation();

  //その他
  const [nftArrayState, setNftArray] = useState([]);
  const [nftOwnArrayState, setNftOwnArrayState] = useState([]);
  const [partnerNftArrayState, setPartnerNftArray] = useState([]);
  const [uniqueArrayState, setUniqueArray] = useState(null);
  const [backArrayState, setBackArray] = useState([]);
  const [nftType, setNftType] = useState('home');
  const [loadingState, setLoadingState] = useState(false);
  const [metaLoadingState, setMetaLoadingState] = useState(false);
  const [noMetaMaskState, setNoMetaMaskState] = useState(false);
  const [showDownloadApp, setShowDownloadApp] = useState(false);
  const [hatenaState, setHatenaState] = useState(false);
  const [nftPartnerDetailID, setNFTPartnerDetailID] = useState(null);
  const [isShowUniqueListState, setIsShowUniqueState] = useState(false);
  const [uniqueState, setUniqueState] = useState(null);

  //URLの末尾を取得
  //var roomID = window.location.pathname;
  const urlParam = useParams();
  var roomID = urlParam.id; //URL取得
  let showThisNFT = roomID == 'makopt' || roomID == '144987874' ? true : false;

  const navigate = useNavigate();

  //初回ロード時
  useEffect(() => {
    startAnimation();

    //パートナーNFT一覧を取得
    getPartnerNFT();

    //アクセス
    AddAccess('page-view', 'nftlist');
  }, []);

  useEffect(() => {
    if (nftType != 'home') {
      //アクセス
      AddAccess('click', 'nftTab', nftType);
    }

    if (uniqueState != null) {
      //setIsShowUniqueState(false);
      setUniqueState(null);
    }
  }, [nftType]);

  useEffect(() => {
    if (uniqueState != null) {
      getUniqueList();
    }
  }, [uniqueState]);

  async function getUniqueList() {
    const partnerNFT = await DataModel.getPartnerNFT(uniqueState, 'd', i18n.language);

    console.log(partnerNFT);
    setUniqueArray(partnerNFT);
  }

  //アニメーション
  function startAnimation() {
    KUTE.fromTo(
      '#nftListRight',
      { opacity: 0 },
      { opacity: 1 },
      { duration: 100, easing: 'easingSinusoidalIn' },
    ).start();
  }

  //パートナーのNFTを取得
  const getPartnerNFT = async () => {
    const partnerNFT = await DataModel.getPartnerNFT('list', 'd', i18n.language);
    setPartnerNftArray(partnerNFT);
  };

  // //NFTのリスト取得
  // async function getNFTList(walletAddress) {
  //   //ローディング中
  //   setLoadingState(true);

  //   //NFTデータ取得
  //   const nftList = await DataModel.getNFTList(walletAddress);
  //   if (nftList != null) {
  //     //NFTデータをコンバート
  //     const nftArray = ConvertNFT(nftList);
  //     setNftArray(nftArray);
  //   }

  //   //ローディング終了
  //   setLoadingState(false);
  // }

  //戻るタップ
  const tapBackArrow = () => {
    //setIsShowUniqueState(false);
    setUniqueState(null);
  };

  //背景をタップ時
  const tapBack = () => {
    if (isFaceScreen) {
      if (isMobile) {
        //navigate('/');
        closeAnim();
      } else if (isElectron) {
        window.myapi.closeWindow();
      } else {
        navigate('/app');
      }
    } else {
      if (isMobile) {
        closeAnim();
      } else {
        setPageState('main');
      }
    }
  };

  function closeAnim() {
    let kute = KUTE.to(
      '#nftListRight',
      { top: '900px' },
      {
        duration: 300,
        easing: 'easingCubicOut',
        onComplete: () => {
          setPageState('main');
        },
      },
    );
    kute.start();
  }

  useEffect(() => {
    if (isMobile) {
      let kute = KUTE.to(
        '#nftListRight',
        { top: 'calc(env(safe-area-inset-top) + 0px)' },
        {
          duration: 300,
          easing: 'easingCubicOut',
          onComplete: () => {},
        },
      );
      kute.start();
    }
  }, []);

  //レンダービュー
  const renderScreen = () => {
    return (
      <>
        {/*ダウンロードアプリの表示*/}
        {showDownloadApp && <DownloadApp setShowDownloadApp={setShowDownloadApp} />}

        {/*メタマスクをインストールして*/}
        {noMetaMaskState && <NoMetaMask setNoMetaMaskState={setNoMetaMaskState} />}

        {nftPartnerDetailID != null && (
          <NFTPartnerDetail
            setNFTPartnerDetaiID={setNFTPartnerDetailID}
            nftPartnerDetailID={nftPartnerDetailID}
          />
        )}

        {/*ローディング*/}
        <Loading loadingState={metaLoadingState} />

        {/* NFTリストの表示　*/}
        {isFaceScreen == false && <div id="transparentBox" onClick={tapBack}></div>}

        <div id="nftListRight">
          {/* ヘッダータブエリア */}
          <div id="nftHeaderArea">
            {roomID != '/face' && (
              <div id="nftCloseButton">
                <CloseSVG onClick={tapBack} />
              </div>
            )}
            <div id="nftHeader">
              <div
                id="nftFace"
                className={nftType == 'home' ? 'nftHeaderDiv selected' : 'nftHeaderDiv'}
                onClick={() => setNftType('home')}>
                {/* <ProfileSVG /> */}
                <div className="nftHeaderTitle">{t('nft.All Avatars')}</div>
              </div>
              <div></div>
              <div
                id="nftBack"
                className={nftType == 'mynft' ? 'nftHeaderDiv selected' : 'nftHeaderDiv'}
                onClick={() => setNftType('mynft')}>
                {/* <BackSVG /> */}
                <div className="nftHeaderTitle">{t('nft.My NFT Avatars')}</div>
              </div>
              <div></div>
              {/* 
              {userType !== 'viewer' && (
                <div
                  id="nftBack"
                  className={nftType == 'background' ? 'nftHeaderDiv selected' : 'nftHeaderDiv'}
                  onClick={() => setNftType('background')}>
                  <div className="nftHeaderTitle">{t('nft.Background')}</div>
                </div>
              )} */}
            </div>
          </div>

          <div
            id="nftListRightScroll"
            className={nftType != 'home' && nftType != 'casual' ? 'paddingWrap' : 'nopadding'}>
            {uniqueState == null ? (
              <>
                {/* NFTの一覧 */}
                {nftType == 'home' && renderFacelessNFT()}
                {nftType == 'mynft' && <NFTMy />}
                {nftType == 'background' && <NFTBackground setNftType={setNftType} />}
                {nftType == 'BGM' && <NFTBGM setNftType={setNftType} />}
                {nftType == 'addMyAvatar' && <NFTMyCustom setNftType={setNftType} />}
              </>
            ) : (
              renderCollectionList()
            )}
          </div>
        </div>
      </>
    );
  };

  //フェイスレスオリジナルNFTリスト
  const renderFacelessNFT = () => {
    return (
      <>
        {/* <div id="nftPartnerTitleWrap">
          {hatenaState && (
            <div id="nftPartnerTitleHatenaDetail">
              Check supported NFT list to know your NFTs are available Etherium and Polygon are
              supported.
            </div>
          )}
          <div id="nftPartnerTitle">{t("nft.Creator's original")}</div>
        </div> */}

        <div className="renew">
          {showThisNFT == false && (
            <div id="nftTypeExplain" style={{ padding: '20px 20px 10px 20px' }}>
              <div className="nftTypeItem">
                <img src={getImagePath() + '/icons/dotlineCircle.png'} />{' '}
                <span>{t('nft.Anyone')}</span>
              </div>
              <div className="nftTypeItem">
                <img src={getImagePath() + '/icons/holdersIcon.png'} />
                <span>{t('nft.All holders')}</span>
              </div>
              <div className="nftTypeItem">
                <img src={getImagePath() + '/icons/uniqueHolderIcon.png'} />
                <span>{t('nft.Only unique holder')}</span>
              </div>
            </div>
          )}

          {showThisNFT && (
            <>
              <div>
                <img
                  src={getImagePath() + '/header/2dme.png'}
                  style={{ width: '65px', lineHeight: '20px', paddingTop: '15px' }}
                />
              </div>
              <img
                className="add2dmebutton"
                onClick={() => setNftType('addMyAvatar')}
                src={getImagePath() + '/buttons/add2dme.png'}
                style={{
                  width: '100%',
                  paddingTop: '10px',
                  paddingBottom: '10px',
                  cursor: 'pointer',
                }}
              />
              {/* <div className="nftTitleEach">Human Style </div> */}
              {/* <div className="nftPartnerList myAvatarList"> */}
              {/* <div className="svgItem">
                <AddMyAvatarSVG onClick={() => setNftType('addMyAvatar')} />
              </div> */}

              {/* <NFTItem
                key={11111}
                imageURL={''}
                type={'pro'}
                nftID={'facelessboy'}
                limit={'anyone'}
                showType="partnerList"
              />{' '}
              <NFTItem
                key={11113}
                imageURL={''}
                type={'pro'}
                nftID={'facelessboy'}
                limit={'anyone'}
                showType="partnerList"
              />{' '}
              <NFTItem
                key={11115}
                imageURL={''}
                type={'pro'}
                nftID={'facelessboy'}
                limit={'anyone'}
                showType="partnerList"
              /> */}
              {/* </div> */}
            </>
          )}

          <>
            {/*ローディング中 */}
            {partnerNftArrayState.length < 1 && (
              <>
                <div id="nftListHolder" style={{ padding: '0 20px' }}>
                  <ListSVG />
                </div>
              </>
            )}

            {/*パートナーのNFT一覧 */}
            {partnerNftArrayState.map((category) => (
              <>
                <div className="nftTitleEach">{category.categoryName} </div>
                <div className="nftPartnerList">
                  {category.list != null && (
                    <>
                      {category.list.map((list, index) => (
                        <>
                          {list.type == 'pro' && (
                            <NFTItem
                              key={list.nftID}
                              imageURL={list.imageURL}
                              type={list.type}
                              nftID={list.nftID}
                              limit={list.whocanuse}
                              nftName={list.name}
                              showType="partnerList"
                            />
                          )}
                          {list.type == 'uniqueList' && (
                            <NFTItem
                              key={list.nftID}
                              imageURL={list.imageURL}
                              type={list.type}
                              nftID={list.nftID}
                              limit={list.whocanuse}
                              nftName={list.name}
                              setIsShowUniqueState={setIsShowUniqueState}
                              setUniqueState={setUniqueState}
                              uniqueState={list.uniqueState}
                              showType="partnerList"
                            />
                          )}
                        </>
                      ))}
                    </>
                  )}
                </div>
              </>
            ))}

            {partnerNftArrayState.length > 0 && (
              <>
                {showThisNFT && <div className="nftTitleEach">Testing</div>}
                <div className="nftPartnerList">
                  {showThisNFT && (
                    <>
                      <NFTItem
                        imageURL={'timeless'}
                        thumbURL={'images/nft/thumb/timeless.png'}
                        type={'pro'}
                        nftID="ethereum-0x495f947276749ce646f68ac8c248420045cb7b5e-6809306188428173666073685742513789835067604049849918034403299165762022801409"
                        showType="partnerList"
                        limit="anyone"
                        nftName="Cool Collection『#017』"
                      />

                      <NFTItem
                        imageURL={'timeless'}
                        thumbURL={'images/nft/thumb/timeless.png'}
                        type={'pro'}
                        nftID="ethereum-0x495f947276749ce646f68ac8c248420045cb7b5e-115742538746809213209730468154594685346766595448918885480630280992210020204545"
                        showType="partnerList"
                        limit="anyone"
                        nftName="Cool Collection『#017』"
                      />

                      <NFTItem
                        imageURL={'timeless'}
                        thumbURL={'images/nft/thumb/timeless.png'}
                        type={'pro'}
                        nftID="ethereum-0x495f947276749ce646f68ac8c248420045cb7b5e-115742538746809213209730468154594685346766595448918885480630280973518322532353"
                        showType="partnerList"
                        limit="anyone"
                        nftName="Cool Collection『#017』"
                      />

                      <NFTItem
                        imageURL={'bighatmonkey'}
                        thumbURL={'images/nft/thumb/bighatmonkey.png'}
                        type={'pro'}
                        nftID="ethereum-0x7fa162d3d44fe8d30e344cc000493da7cb6c6fbb-1696"
                        showType="partnerList"
                        limit="holder"
                        nftName="BigHatMonkey"
                      />

                      <NFTItem
                        imageURL={'babymonkey'}
                        thumbURL={'images/nft/thumb/babymonkey.png'}
                        type={'pro'}
                        nftID="ethereum-0x495f947276749ce646f68ac8c248420045cb7b5e-74174376043700788367701425876656584030327428720026632551187348737675828920321"
                        showType="partnerList"
                        limit="holder"
                        nftName="Babymonkey"
                      />

                      <NFTItem
                        imageURL={'worldofwoman'}
                        thumbURL={'images/nft/thumb/wow.png'}
                        type={'pro'}
                        nftID="ethereum-0xe785e82358879f061bc3dcac6f0444462d4b5330-906"
                        showType="partnerList"
                        limit="anyone"
                        nftName="WoW"
                      />

                      <NFTItem
                        imageURL={'azuki'}
                        thumbURL={'images/nft/thumb/azuki.png'}
                        type={'pro'}
                        nftID="ethereum-0xed5af388653567af2f388e6224dc7c4b3241c544-7311"
                        showType="partnerList"
                        limit="anyone"
                        nftName="Azuki"
                      />

                      <NFTItem
                        imageURL={'timeless'}
                        thumbURL={'images/nft/thumb/timeless.png'}
                        type={'pro'}
                        nftID="buson"
                        showType="partnerList"
                        limit="anyone"
                        nftName="Buson"
                      />

                      <NFTItem
                        imageURL={'timeless'}
                        thumbURL={'images/nft/thumb/timeless.png'}
                        type={'pro'}
                        nftID="bluechip"
                        showType="partnerList"
                        limit="anyone"
                        nftName="Blue Chip"
                      />

                      <NFTItem
                        imageURL={'timeless'}
                        thumbURL={'images/nft/thumb/timeless.png'}
                        type={'pro'}
                        nftID="ethereum-0x495f947276749ce646f68ac8c248420045cb7b5e-87383727123620161737292094198014250315741856288672271608440919151112460697601"
                        showType="partnerList"
                        limit="anyone"
                        nftName="Yoshioka/No.1"
                      />

                      <NFTItem
                        imageURL={'timeless'}
                        thumbURL={'images/nft/thumb/timeless.png'}
                        type={'pro'}
                        nftID="ethereum-0x495f947276749ce646f68ac8c248420045cb7b5e-87383727123620161737292094198014250315741856288672271608440919162107576975361"
                        showType="partnerList"
                        limit="anyone"
                        nftName="Yoshioka/No.5"
                      />

                      <NFTItem
                        imageURL={'timeless'}
                        thumbURL={'images/nft/thumb/timeless.png'}
                        type={'pro'}
                        nftID="ethereum-0x495f947276749ce646f68ac8c248420045cb7b5e-87383727123620161737292094198014250315741856288672271608440919154410995580929"
                        showType="partnerList"
                        limit="anyone"
                        nftName="Yoshioka/No.2"
                      />

                      <NFTItem
                        imageURL={'timeless'}
                        thumbURL={'images/nft/thumb/timeless.png'}
                        type={'pro'}
                        nftID="ethereum-0x495f947276749ce646f68ac8c248420045cb7b5e-106212411486624036609867579056613694894334480661660538001499774931573831368705"
                        showType="partnerList"
                        limit="anyone"
                        nftName="Crypto bears"
                      />

                      <NFTItem
                        imageURL={'timeless'}
                        thumbURL={'images/nft/thumb/timeless.png'}
                        type={'pro'}
                        nftID="ethereum-0x495f947276749ce646f68ac8c248420045cb7b5e-106212411486624036609867579056613694894334480661660538001499774945867482529793"
                        showType="partnerList"
                        limit="anyone"
                        nftName="Crypto bears #005"
                      />

                      <NFTItem
                        imageURL={'timeless'}
                        thumbURL={'images/nft/thumb/timeless.png'}
                        type={'pro'}
                        nftID="ethereum-0x495f947276749ce646f68ac8c248420045cb7b5e-106212411486624036609867579056613694894334480661660538001499775003042087174145"
                        showType="partnerList"
                        limit="anyone"
                        nftName="Crypto bears #036"
                      />

                      <NFTItem
                        imageURL={'timeless'}
                        thumbURL={'images/nft/thumb/timeless.png'}
                        type={'pro'}
                        nftID="ethereum-0xb47e3cd837ddf8e4c57f05d70ab865de6e193bbb-1968"
                        showType="partnerList"
                        limit="anyone"
                        nftName="CryptoPunk #1968"
                      />

                      <NFTItem
                        imageURL={'timeless'}
                        thumbURL={'images/nft/thumb/timeless.png'}
                        type={'pro'}
                        nftID="ethereum-0x82712d0052c6d8185383b5554a071c440b902992-10000"
                        showType="partnerList"
                        limit="anyone"
                        nftName="CuriousAddy"
                      />
                      <NFTItem
                        imageURL={'timeless'}
                        thumbURL={'images/nft/thumb/timeless.png'}
                        type={'pro'}
                        nftID="ethereum-0x82712d0052c6d8185383b5554a071c440b902992-9991"
                        showType="partnerList"
                        limit="anyone"
                        nftName="CuriousAddy"
                      />

                      <NFTItem
                        imageURL={'timeless'}
                        thumbURL={'images/nft/thumb/timeless.png'}
                        type={'pro'}
                        nftID="ethereum-0x82712d0052c6d8185383b5554a071c440b902992-9987"
                        showType="partnerList"
                        limit="anyone"
                        nftName="CuriousAddy"
                      />

                      <NFTItem
                        imageURL={'timeless'}
                        thumbURL={'images/nft/thumb/timeless.png'}
                        type={'pro'}
                        nftID="test1"
                        showType="partnerList"
                        limit="anyone"
                        nftName="test1"
                      />
                      <NFTItem
                        imageURL={'timeless'}
                        thumbURL={'images/nft/thumb/timeless.png'}
                        type={'pro'}
                        nftID="custom6768bbd6-eb3b-40d5-b8c3-5ead7424c65e"
                        showType="partnerList"
                        limit="anyone"
                        nftName="test2"
                      />

                      <NFTItem
                        imageURL={'timeless'}
                        thumbURL={'images/nft/thumb/timeless.png'}
                        type={'pro'}
                        nftID="test3"
                        showType="partnerList"
                        limit="anyone"
                        nftName="test3"
                      />

                      <NFTItem
                        imageURL={'timeless'}
                        thumbURL={'images/nft/thumb/timeless.png'}
                        type={'pro'}
                        nftID="test5"
                        showType="partnerList"
                        limit="anyone"
                        nftName="test5"
                      />
                      <NFTItem
                        imageURL={'timeless'}
                        thumbURL={'images/nft/thumb/timeless.png'}
                        type={'pro'}
                        nftID="test6"
                        showType="partnerList"
                        limit="anyone"
                        nftName="test6"
                      />
                    </>
                  )}
                </div>
                {showThisNFT == false && (
                  <div id="selectYourNFTText" style={{ padding: '0 20px' }}>
                    <button onClick={() => setNftType('mynft')}>{t('nft.Select your NFT')}</button>
                  </div>
                )}
              </>
            )}
          </>
        </div>
      </>
    );
  };

  //ユニークリストの表示
  const renderCollectionList = () => {
    return (
      <>
        {uniqueArrayState != null && uniqueArrayState.collectionList?.length > 0 && (
          <>
            <div id="nftListTitle">
              <BackArrowSVG onClick={tapBackArrow} />
              <div> {uniqueArrayState.collectionName}</div>
            </div>

            {/*パートナーのNFT一覧 */}
            {uniqueArrayState.collectionList.map((category, index) => (
              <>
                {category.categoryName != '' && (
                  <div className="nftTitleEach">{category.categoryName} </div>
                )}
                <div className="nftPartnerList">
                  {category.list.map((list, index) => (
                    <>
                      {list.type == 'pro' && (
                        <NFTItem
                          key={list.nftID}
                          imageURL={list.imageURL}
                          type={list.type}
                          nftID={list.nftID}
                          limit={list.whocanuse}
                          nftName={list.name}
                          showType="partnerList"
                        />
                      )}
                    </>
                  ))}
                </div>
              </>
            ))}
          </>
        )}
      </>
    );
  };

  //背景リストの表示
  const renderBackround = () => {
    return (
      <>
        {/*背景一覧 */}
        <div id="nftListTitle3">{t('nft.Select background')}</div>
        <div id="nftBackgroundList">
          <NFTItem imageURL={'whiteYellow.png'} type={'back'} />
          <NFTItem imageURL={'purple.png'} type={'back'} />
          <NFTItem imageURL={'pink.png'} type={'back'} />
          <NFTItem imageURL={'red.png'} type={'back'} />
          <NFTItem imageURL={'hackatao.jpg'} type={'back'} />
          <NFTItem imageURL={'space1.jpg'} type={'back'} />
          <NFTItem imageURL={'hongkong1.jpg'} type={'back'} />
          <NFTItem imageURL={'black1.png'} type={'back'} />
          {/* <NFTItem imageURL={'llac.png'} type={'back'} /> */}

          <NFTItem imageURL={'greenBack.png'} type={'back'} />
          <NFTItem imageURL={'h1.jpg'} type={'back'} />
          <NFTItem imageURL={'h2.jpg'} type={'back'} />

          {showThisNFT && (
            <>
              <NFTItem imageURL={'h4.jpg'} type={'back'} />

              {/* <NFTItem imageURL={'h3.jpg'} type={'back'} />
              <NFTItem imageURL={'h4.jpg'} type={'back'} />
              <NFTItem imageURL={'h6.jpg'} type={'back'} />
              <NFTItem imageURL={'h7.jpg'} type={'back'} /> */}
            </>
          )}
        </div>
      </>
    );
  };

  return renderScreen();
}
